import { classes } from "@theme/helpers";
import { HTMLShopifySectionElement } from "@theme/html-custom-element";

class FeaturedCardSlider extends HTMLShopifySectionElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    if (this.refs.swiper) {
      this.swiper = new Swiper(this.refs.swiper, {
        navigation: {
          nextEl: this.refs.next,
          prevEl: this.refs.prev,
        },
        scrollbar: {
          el: this.refs.scrollbar,
        },
        loop: true,
      });
    }

    if (this.refs.carousel) {
      this.on("click", this, this.handleClickEvent.bind(this));
      this.on("click", this.refs.closeButton, this.handleCloseEvent.bind(this));
    }
  }

  handleClickEvent() {
    if (this.classList.contains(classes.active)) return;

    this.classList.add(classes.active);

    // Recalculate now that the carousel is visible, so slide widths are correct.
    if (this.swiper) this.swiper.update();
  }

  handleCloseEvent(event) {
    event.preventDefault();
    event.stopPropagation();

    this.classList.remove(classes.active);
  }

  disconnectedCallback() {
    if (super.disconnectedCallback) super.disconnectedCallback();

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get("featured-card-slider"))
  customElements.define("featured-card-slider", FeaturedCardSlider);
